const itemsTypes = {
  ITEMS_TABLE_STATE_SET: 'ITEMS/TABLE_STATE_SET',
  ITEMS_TABLE_STATE_RESET: 'ITEMS/TABLE_STATE_RESET',
};
export default itemsTypes;